<template>
   <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/15.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十五次全国代表大会简介</p>
                            <p class="margin1">1997年9月12日至18日在北京举行。大会正式代表2048人，特邀代表60人，代表全国5800万名党员。江泽民作《高举邓小平理论伟大旗帜，把建设有中国特色社会主义事业全面推向二十一世纪》的报告。大会首次使用“邓小平理论”概念，提出了社会主义初级阶段的基本纲领，规划了跨世纪发展的战略部署。大会通过的《中国共产党章程修正案》明确规定把邓小平理论确立为党的指导思想。大会通过了《关于十四届中央委员会报告的决议》、《关于〈中国共产党章程修正案〉的决议》和《关于中央纪律检查委员会工作报告的决议》。大会选举了由193名委员和151名候补委员组成的中央委员会，选举了由115名委员组成的中央纪律检查委员会。随后召开的十五届一中全会选举了中央政治局及其常务委员会；选举江泽民为中央委员会总书记；决定江泽民为中央军事委员会主席；批准尉健行为中央纪律检查委员会书记。
                            </p>
                        </div>
</template>

<script>
export default {

}
</script>

<style>

</style>